<script setup lang="ts">
const {$image} = useNuxtApp();
const route = useRoute();
const config = useRuntimeConfig();

// This will be reactive even you change title/description above
useHead({
	htmlAttrs: {
		lang: 'de'
	},

	title: 'SPOFERAN und resultastic Guide',

	meta: [
		{charset: 'utf-8'},
		{name: 'viewport', content: 'width=device-width, initial-scale=1.0, minimum-scale=1.0 maximum-scale=1.0'},
		{
			name: 'description',
			content: 'Finde Anleitungen, Tipps und Tricks zur Nutzung von SPOFERAN und resultastic.'
		},
		{name: 'author', content: 'SPOFERAN GmbH'},
		{name: 'theme-color', content: '#008200'}, // Neutral white as we have specific page colors for events, clubs, etc.

		{
			'property': 'og:title',
			'content': `SPOFERAN und resultastic Guide`,
		},
		{
			'property': 'og:type',
			'content': 'website',
		},
		{
			'property': 'og:site_name',
			'content': 'SPOFERAN und resultastic Guide'
		},
		{
			'property': 'og:description',
			'content': 'Finde Anleitungen, Tipps und Tricks zur Nutzung von SPOFERAN und resultastic.',
		},
		{
			'property': 'og:image',
			'content': process.env.STORAGE_URL + '/images/spoferan-feature-image.jpg',
		},

		// Fix for IE 11 rendering issues
		{
			'http-equiv': 'X-UA-Compatible',
			'content': 'IE=edge'
		},

		// Activate iOS PWA Splash Screen
		{name: 'apple-mobile-web-app-capable', content: 'yes'}
	],
	link: [
		{rel: 'shortcut icon', type: 'image/x-icon', href: '/images/favicons/favicon.ico'},
		{rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', href: '/images/favicons/apple-touch-icon.png'},
		{rel: 'icon', type: 'image/png', sizes: '32x32', href: '/images/favicons/favicon-32x32.png'},
		{rel: 'icon', type: 'image/png', sizes: '16x16', href: '/images/favicons/favicon-16x16.png'},
		{rel: 'mask-icon', type: 'image/png', color: '#008200', href: '/images/favicons/safari-pinned-tab.svg'}
	]
})
</script>

<template>
	<NuxtLayout>
		<NuxtPage/>
	</NuxtLayout>
</template>
